import {useMutation, useQueryClient} from '@tanstack/react-query';
import Country from '../../../networking/models/Country';
import CountryRepository from '../../../networking/repos/CountryRepository';
import {CountryQueryKey} from './Query';

interface CountryChangeRequest {
    country: Country;
    continentId: number;
}

export const useCountrySaveMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (request: CountryChangeRequest) => {
            const repo = new CountryRepository(request.continentId);

            return repo.save(request.country);
        },
        onSuccess: (country: Country, request: CountryChangeRequest) =>
            queryClient.invalidateQueries(CountryQueryKey.base(request.continentId))
    })
};

export const useCountryDeleteMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (request: CountryChangeRequest) => {
            const repo = new CountryRepository(request.continentId);

            return repo.destroy(request.country);
        },
        onSuccess: (country: Country, request: CountryChangeRequest) =>
            queryClient.invalidateQueries(CountryQueryKey.base(request.continentId))
    })
};
